
/**
 * @author Sascha Dobschal <s.dobschal@tdsoftware.de>
 * date 07/16/2018
 */

export default {

};


// WEBPACK FOOTER //
// ./src/store/actions.js